import AuthenticationStore from '@components/membership/stores/AuthenticationStore';
import { Box, CssBaseline, SwipeableDrawer, styled } from "@mui/material";
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import Login from '../common/Login';

interface LoginDrawerProps {
    authenticationStore: AuthenticationStore,
}

const LoginDrawer: FC<LoginDrawerProps> = observer(({ authenticationStore }) => {
    const { isLoginDrawerOpen, setIsLoginDrawerOpen } = authenticationStore;

    return (
        <>
            <CssBaseline />
            <SwipeableDrawer
                sx={{
                    ".MuiDrawer-paper ": {
                        borderTopLeftRadius: 14,
                        borderTopRightRadius: 14,
                        height: "86%"
                    },

                }}
                anchor="bottom"
                open={isLoginDrawerOpen}
                onClose={() => setIsLoginDrawerOpen(false)}
                onOpen={() => setIsLoginDrawerOpen(true)}
                disableSwipeToOpen
                ModalProps={{
                    keepMounted: false,
                }}
            >
                <Box position={"relative"} sx={{ overflowY: "hidden" }}>
                    <Box
                        pl={1}
                        pt={1}
                        sx={(theme) => ({
                            position: 'relative',
                            border: 9,
                            // backgroundColor: theme.palette.primary.main,
                            borderColor: "Background",
                            borderTopLeftRadius: 12,
                            borderTopRightRadius: 12,
                            visibility: 'visible',
                            right: 0,
                            left: 0,
                        })}
                    >
                        <Puller />
                    </Box>
                    <Box
                        p={2}
                        pt={0}
                        pb={12}
                        position={"relative"}
                        sx={{
                            height: '100%',
                            overflow: 'auto',
                        }}
                    >
                        <Login authenticationStore={authenticationStore} />
                    </Box>
                </Box>
            </SwipeableDrawer >
        </>
    )
})

export default LoginDrawer;

const Puller = styled(Box)(({ theme }) => ({
    width: 52,
    height: 6,
    zIndex: 1,
    backgroundColor: theme.palette.primary.light,
    borderRadius: 50,
    border: `1px solid ${theme.palette.primary.main}`,
    position: 'absolute',
    top: -3,
    left: 'calc(50% - 26px)',
}));